import "./App.css";
import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import Navigation from "./components/navigation/Navigation";
import AnnouncementBar from "./components/announcement/AnnouncementBar";
import ScrollToTopProductPage from "./components/ScrollToTopProductPage";

/* Pages */
import Expertise from "./pages/expertise";
import Digital from "./pages/digital/Digital";
import About from "./pages/about";
import Home from "./pages/home/Home";
import UXUIDesign from "./pages/services/Ux-UI-design";
import EnterpriceApp from "./pages/services/enterpriceapp/EnterpriceApp";
import Salesforce from "./pages/technology/salesforce";
import Servicenow from "./pages/technology/servicenow";
import Netsuite from "./pages/technology/netsuite";
import Oracle from "./pages/technology/oracle";
import Opensource from "./pages/technology/opensource";
import Sharepoint from "./pages/technology/sharepoint";
import Blockchain from "./pages/technology/blockchain";
import ExtendedReality from "./pages/insights/extended-reality";
import Cognitive from "./pages/insights/cognitive-computing";
import Datascience from "./components/ai-data-science/Datascience";
import Testing from "./components/testing/Testing";
import MobileWebDev from "./pages/services/mobile-web-dev/MobileWebDev";
import ApiIntergration from "./pages/services/api-intergration/ApiIntergration";
import AiConsultingAndStrategy from "./pages/services/ai-consulting-and-strategy/AiConsultingAndStrategy";
import ProductDevelopment_MultiListCard from "./pages/services/product-development/ProductDevelopment";
import ResposibleAndEthicalAI from "./pages/services/ResposibleAndEthicalAI";
import CareerDetail from "./pages/career-detail/Careerdetail";
import BusinessIntelligence from "./pages/insights/business-intelligence";
import SecurityAndCompliance from "./pages/trust/security-and-compliance/SecurityAndCompliance";
import PrivacyAndDataHandling from "./pages/trust/privacy-and-data-handling/PrivacyAndDataHandling";
import CertificationsAndPartnerPrograms from "./pages/trust/certifications-and-partner-programs/CertificationsAndPartnerPrograms";
import ProcurementFAQ from "./pages/trust/procurement-faq/ProcurementFAQ";
import Ai_Blockchain from "./pages/Blockchain/Ai_Blockchain";
import Cloud from "./pages/insights/cloud";
import Careers from "./pages/careers/Careers";
import UpdatePage from "./pages/update/UpdatePage";
import Product from "./pages/Blockchain/products/Product";
import Blog from "./pages/blog/Blog";
import BlogDetail from "./pages/blog/BlogDetail";
import blogPosts from "./pages/blog/blogData";
import ElverveBranded from "./pages/elverve-branded/ElverveBranded";

/* ---------------- ROUTE DATA ---------------- */

const routeTitles = {
  "/": "Elverve",
  "/about": "Elverve | About",
  "/expertise": "Elverve | Expertise",
  "/digital": "Elverve | Digital",
  "/services/ux-ui-design": "Elverve | UX/UI Design",
  "/services/mobile-web-development": "Elverve | Mobile Web Development",
  "/services/api-intergration": "Elverve | API Integration",
  "/services/enterprice-application": "Elverve | Enterprise Application",
  "/services/ai-consulting-and-strategy": "Elverve | AI Consulting & Strategy",
  "/services/product-development": "Elverve | Product Development",
  "/services/responsible-and-ethical-ai": "Elverve | Responsible & Ethical AI",
  "/technology/salesforce": "Elverve | Salesforce",
  "/technology/service-now": "Elverve | ServiceNow",
  "/technology/netsuite": "Elverve | NetSuite",
  "/technology/oracle": "Elverve | Oracle",
  "/technology/open-source": "Elverve | Open Source",
  "/technology/sharepoint": "Elverve | SharePoint",
  "/technology/blockchain": "Elverve | Blockchain",
  "/insights/extended-reality": "Elverve | Extended Reality",
  "/insights/cognitive": "Elverve | Cognitive Computing",
  "/insights/business-intelligence": "Elverve | Business Intelligence",
  "/insights/cloud": "Elverve | Cloud",
  "/data-science": "Elverve | Data Science",
  "/testing": "Elverve | Testing",
  "/careers": "Elverve | Careers",
  "/career-detail": "Elverve | Career Detail",
  "/trust/security-and-compliance": "Elverve | Security & Compliance",
  "/trust/privacy-and-data-handling": "Elverve | Privacy & Data Handling",
  "/trust/certifications-and-partner-programs":
    "Elverve | Certifications & Partner Programs",
  "/trust/procurement-faq": "Elverve | Procurement FAQ",
  "/portfolio": "Elverve | Portfolio",
  "/blog": "Elverve | Blog",
  "/news/our-new-ai-hub-is-officially-live-in-coimbatore":
    "Elverve | AI Hub Live",
  "/ai-readiness": "Elverve | AI Readiness Scorecard",
};

const routeDescriptions = {
  "/": "Elverve is an enterprise AI and Agentic AI company building autonomous agents, intelligent automation, and AI-native systems for global businesses. From AI consulting and strategy to custom agent development, enterprise software, and cloud modernization, we help enterprises embed AI into operations, decision-making, and customer experience — securely, responsibly, and at scale.",

  "/about":
    "Discover Elverve’s mission, vision, leadership team, and commitment to delivering cutting-edge AI, enterprise software, and digital transformation solutions worldwide.",

  "/expertise":
    "Explore Elverve’s expertise in AI consulting, enterprise application development, blockchain technology, cloud computing, and scalable digital solutions.",

  "/digital":
    "End-to-end digital transformation services including web development, mobile app development, UI/UX design, and enterprise software engineering.",

  "/services/ux-ui-design":
    "Professional UX/UI design services focused on user experience strategy, wireframing, prototyping, usability testing, and modern digital product design.",

  "/services/mobile-web-development":
    "Custom mobile app and responsive web development services using modern frameworks for scalable, secure, and high-performance applications.",

  "/services/api-intergration":
    "Secure API integration services connecting enterprise systems, third-party platforms, SaaS tools, and cloud applications seamlessly.",

  "/services/enterprice-application":
    "Enterprise application development services delivering scalable, secure, and business-focused digital solutions for modern organizations.",

  "/services/ai-consulting-and-strategy":
    "AI consulting and strategy services helping businesses implement machine learning, automation, predictive analytics, and intelligent decision-making systems.",

  "/services/product-development":
    "Complete product development lifecycle services from idea validation and UI/UX design to development, testing, deployment, and scaling.",

  "/services/responsible-and-ethical-ai":
    "Responsible and ethical AI development services ensuring transparency, governance, fairness, compliance, and secure AI implementation.",

  "/technology/salesforce":
    "Salesforce CRM consulting services including implementation, customization, integration, automation, and enterprise CRM optimization.",

  "/technology/service-now":
    "ServiceNow consulting and workflow automation solutions for ITSM, enterprise process optimization, and digital operations management.",

  "/technology/netsuite":
    "NetSuite ERP consulting services for financial management, CRM, supply chain, and enterprise resource planning optimization.",

  "/technology/oracle":
    "Oracle consulting solutions including database management, ERP implementation, cloud services, and enterprise performance optimization.",

  "/technology/open-source":
    "Open-source software development services including custom applications, CMS platforms, backend systems, and scalable digital solutions.",

  "/technology/sharepoint":
    "Microsoft SharePoint development and consulting services for enterprise collaboration, document management, and workflow automation.",

  "/technology/blockchain":
    "Blockchain development services including smart contracts, decentralized applications (dApps), Web3 solutions, and enterprise blockchain integration.",

  "/insights/extended-reality":
    "Insights on Extended Reality (XR), AR, and VR technologies transforming enterprise innovation, immersive experiences, and digital engagement.",

  "/insights/cognitive":
    "Cognitive computing solutions and insights covering AI, machine learning, natural language processing, and intelligent automation strategies.",

  "/insights/business-intelligence":
    "Business intelligence insights and analytics solutions that transform enterprise data into actionable business strategies.",

  "/insights/cloud":
    "Cloud computing solutions including cloud migration, DevOps, infrastructure modernization, and scalable cloud-native application development.",

  "/data-science":
    "AI and data science services including predictive analytics, machine learning model development, big data engineering, and intelligent automation.",

  "/testing":
    "Comprehensive software testing services including automation testing, performance testing, QA consulting, security testing, and quality assurance solutions.",

  "/careers":
    "Explore career opportunities at Elverve and join our team of AI engineers, developers, designers, and digital transformation experts.",

  "/career-detail":
    "Detailed job descriptions, responsibilities, qualifications, and application information for open career opportunities at Elverve.",

  "/trust/security-and-compliance":
    "Enterprise-grade security and compliance policies ensuring data protection, governance, cybersecurity standards, and regulatory compliance.",

  "/trust/privacy-and-data-handling":
    "Learn how Elverve protects user data with strong privacy policies, secure data handling practices, and global compliance standards.",

  "/trust/certifications-and-partner-programs":
    "Explore Elverve’s certifications, technology partnerships, strategic alliances, and global compliance credentials.",

  "/trust/procurement-faq":
    "Procurement FAQ covering vendor onboarding, compliance requirements, documentation, contracts, and enterprise procurement processes.",

  "/portfolio":
    "Explore Elverve’s portfolio of AI, blockchain, enterprise software, cloud, and digital transformation projects delivered to global clients.",
  "/blog":
    "Read the latest insights, articles, and thought leadership from Elverve on AI, blockchain, cloud, digital transformation, and enterprise technology.",
  "/news/our-new-ai-hub-is-officially-live-in-coimbatore":
    "Elverve announces the launch of its new AI Innovation Hub in Coimbatore, advancing AI research, enterprise technology solutions, and digital innovation.",

  "/ai-readiness":
    "Elverve AI Readiness Scorecard to assess your business AI readiness with a guided questionnaire and detailed report.",
};

/* ---------------- SEO COMPONENT ---------------- */

function SEOHelmet() {
  const location = useLocation();
  const currentUrl = window.location.href;

  let title = routeTitles[location.pathname] || "Elverve";
  let description =
    routeDescriptions[location.pathname] || "Elverve official website";

  if (
    location.pathname.startsWith("/portfolio/") &&
    location.pathname !== "/portfolio"
  ) {
    const slug = location.pathname.replace("/portfolio/", "");
    const formattedSlug = slug
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
    title = `Elverve | ${formattedSlug}`;
    description = `Learn more about ${formattedSlug} - a project by Elverve.`;
  }

  if (
    location.pathname.startsWith("/blog/") &&
    location.pathname !== "/blog"
  ) {
    const slug = location.pathname.replace("/blog/", "").replace(/\/$/, "");
    const post = blogPosts.find((p) => p.slug === slug);
    if (post) {
      title = `Elverve | ${post.title}`;
      description = post.description || description;
    }
  }

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      <link rel="canonical" href={currentUrl} />
    </Helmet>
  );
}

/* ---------------- APP ---------------- */

function App() {
  const location = useLocation();
  const [isClosed, setIsClosed] = useState(
    localStorage.getItem("announcementClosed") === "true",
  );
  const shouldHideNavigation = /^\/ai-readiness\/?$/.test(location.pathname);
  const shouldShowAnnouncement = !isClosed && !shouldHideNavigation;

  const handleCloseAnnouncement = () => {
    setIsClosed(true);
    localStorage.setItem("announcementClosed", "true");
  };

  useEffect(() => {
    if (shouldShowAnnouncement) {
      document.body.classList.remove("no-announcement");
    } else {
      document.body.classList.add("no-announcement");
    }
  }, [shouldShowAnnouncement]);

  return (
    <>
      <SEOHelmet />

      {shouldShowAnnouncement && (
        <AnnouncementBar onClose={handleCloseAnnouncement} />
      )}
      {!shouldHideNavigation && <Navigation />}
      <ScrollToTopProductPage />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="expertise" element={<Expertise />} />
        <Route path="digital" element={<Digital />} />
        <Route path="services/ux-ui-design" element={<UXUIDesign />} />
        <Route
          path="services/mobile-web-development"
          element={<MobileWebDev />}
        />
        <Route path="services/api-intergration" element={<ApiIntergration />} />
        <Route
          path="services/enterprice-application"
          element={<EnterpriceApp />}
        />
        <Route
          path="services/ai-consulting-and-strategy"
          element={<AiConsultingAndStrategy />}
        />
        <Route
          path="services/product-development"
          element={<ProductDevelopment_MultiListCard />}
        />
        <Route
          path="services/responsible-and-ethical-ai"
          element={<ResposibleAndEthicalAI />}
        />
        <Route path="technology/salesforce" element={<Salesforce />} />
        <Route path="technology/service-now" element={<Servicenow />} />
        <Route path="technology/netsuite" element={<Netsuite />} />
        <Route path="technology/oracle" element={<Oracle />} />
        <Route path="technology/open-source" element={<Opensource />} />
        <Route path="technology/sharepoint" element={<Sharepoint />} />
        <Route path="technology/blockchain" element={<Blockchain />} />
        <Route path="insights/extended-reality" element={<ExtendedReality />} />
        <Route path="insights/cognitive" element={<Cognitive />} />
        <Route
          path="insights/business-intelligence"
          element={<BusinessIntelligence />}
        />
        <Route path="insights/cloud" element={<Cloud />} />
        <Route path="data-science" element={<Datascience />} />
        <Route path="testing" element={<Testing />} />
        <Route path="careers" element={<Careers />} />
        <Route path="career-detail" element={<CareerDetail />} />
        <Route
          path="trust/security-and-compliance"
          element={<SecurityAndCompliance />}
        />
        <Route
          path="trust/privacy-and-data-handling"
          element={<PrivacyAndDataHandling />}
        />
        <Route
          path="trust/certifications-and-partner-programs"
          element={<CertificationsAndPartnerPrograms />}
        />
        <Route path="trust/procurement-faq" element={<ProcurementFAQ />} />
        <Route path="portfolio" element={<Ai_Blockchain />} />
        <Route path="portfolio/:slug" element={<Product />} />
        <Route
          path="news/our-new-ai-hub-is-officially-live-in-coimbatore"
          element={<UpdatePage />}
        />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/:slug" element={<BlogDetail />} />
        <Route path="ai-readiness" element={<ElverveBranded />} />
      </Routes>
    </>
  );
}

export default App;
